import { useMemo } from "react";
import { flattenTreeForRender } from "@/components/site-builder/modules/CustomFormModule/utils/options/flattenTreeForRender";
import { processOptions } from "@/components/site-builder/modules/CustomFormModule/utils/options/processOptions";
import type { FormBuilderFormField } from "@/types/form-builder";

export function useCustomFormFieldOptions(field: FormBuilderFormField) {
  return useMemo(() => {
    const {
      options = [],
      showAsTree,
      hideParentCheckBoxes,
      alwaysShowHeading,
    } = field;

    const processedOptions = processOptions({
      options,
      showAsTree,
      hideParentCheckBoxes,
      alwaysShowHeading,
    });

    return showAsTree
      ? flattenTreeForRender(processedOptions)
      : processedOptions;
  }, [field]);
}
